const styles = (isMobile) => ({
  container: {
    padding: isMobile ? "16px" : "24px",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    padding: "16px 0",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  backButton: {
    backgroundColor: "#f1f5f9",
    color: "#475569",
    "&:hover": {
      backgroundColor: "#e2e8f0",
    },
  },
  title: {
    fontSize: isMobile ? "24px" : "32px",
    fontWeight: "600",
    color: "#0f172a",
    marginBottom: "4px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
  },
  summaryCardsContainer: {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(4, 1fr)",
    gap: "16px",
    marginBottom: "24px",
  },
  summaryCard: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e2e8f0",
  },
  summaryCardContent: {
    padding: "20px",
    "&:last-child": {
      paddingBottom: "20px",
    },
  },
  summaryCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  summaryCardLabel: {
    fontSize: "12px",
    color: "#64748b",
    fontWeight: "500",
    marginBottom: "4px",
  },
  summaryCardValue: {
    fontSize: isMobile ? "20px" : "24px",
    fontWeight: "600",
    color: "#0f172a",
  },
  summaryCardIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    backgroundColor: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tabsContainer: {
    marginBottom: "24px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "8px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e2e8f0",
  },
  tabContent: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "none",
    border: "1px solid #e2e8f0",
    minHeight: "300px",
    marginTop: "2vh",
  },
  itemBreakdownContainer: {
    padding: "24px",
  },
  inclusionCard: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e2e8f0",
    marginBottom: "16px",
  },
  inclusionCardContent: {
    padding: "20px",
    "&:last-child": {
      paddingBottom: "20px",
    },
  },
  inclusionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  inclusionTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  inclusionIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    backgroundColor: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#475569",
  },
  inclusionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#0f172a",
  },
  boqsContainer: {
    marginTop: "16px",
  },
  boqsList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  boqItem: {
    backgroundColor: "#f8fafc",
    borderRadius: "8px",
    padding: "16px",
    border: "1px solid #e2e8f0",
  },
  boqImageContainer: {
    width: "48px",
    height: "48px",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#e2e8f0",
    flexShrink: 0,
  },
  boqItemName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#0f172a",
  },
  noBoqsContainer: {
    textAlign: "center",
    padding: "32px",
    color: "#64748b",
  },
  noBoqsText: {
    fontSize: "14px",
    color: "#64748b",
  },
  emptyStateCard: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e2e8f0",
    marginBottom: "16px",
  },
  emptyStateContent: {
    padding: "48px 24px",
    textAlign: "center",
  },
  emptyStateText: {
    fontSize: "16px",
    color: "#64748b",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 24px",
    gap: "16px",
  },
  loadingText: {
    fontSize: "16px",
    color: "#64748b",
  },
});

export default styles;
